"use client";

import React from "react";

export type EzoicPlaceholderProps = {
  id: number;
  slotName?: string;
  className?: string;
};

/**
 * Placeholder grezzo per Ezoic.
 * - Viene usato SIA lato server che lato client.
 * - suppressHydrationWarning evita warning se Ezoic modifica il contenuto interno.
 */
const EzoicPlaceholder: React.FC<EzoicPlaceholderProps> = ({ id, slotName, className }) => {
  return (
    <div
      id={`ezoic-pub-ad-placeholder-${id}`}
      className={className}
      data-ezoic-placeholder-id={id}
      data-ezoic-react-slot="true"
      data-ezoic-slot-name={slotName}
      suppressHydrationWarning={true}
    />
  );
};

export default EzoicPlaceholder;
